import api from '../api';

export const sendResultToUI = async (template: any): Promise<void> => {
  await api.post('/ui/test', {
    template,
  });
};
